import { NgClass, NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService, LocalStorageService } from '@univacity/angular/datas';
import { AngularUiModule, DestroyAbleComponent } from '@univacity/angular/ui';
import { Setting } from '@univacity/shared/types';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { filter, takeUntil } from 'rxjs';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'un-default-layout',
  imports: [
    NgClass,
    NgStyle,
    RouterModule,
    NzLayoutModule,
    NzIconModule,
    AngularUiModule,
    HeaderComponent,
    FooterComponent,
  ],
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.less'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DefaultLayoutComponent
  extends DestroyAbleComponent
  implements OnInit
{
  transparent = false;
  isBottom = false;
  transparentColor: string;
  fullWidth: boolean;
  refCode = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private authS: AuthService,
    private localStorage: LocalStorageService
  ) {
    super();
  }

  ngOnInit(): void {
    this.refCode = this.router.url.replace('/r/', '');
    if (this.route.firstChild)
      this.router.events
        .pipe(
          takeUntil(this.dead$),
          filter(() => this.router.navigated)
        )
        .subscribe(() => {
          const { transparent, transparentColor, fullWidth } =
            this.route.snapshot.firstChild?.firstChild?.data || {};
          const {
            transparent: t,
            transparentColor: c,
            fullWidth: f,
          } = this.route.snapshot.firstChild?.data || {};

          this.transparent = !!(transparent || t);
          this.transparentColor = transparentColor || c;
          this.fullWidth = !!(fullWidth || f);

          this.cdr.detectChanges();
        });
    if (this.router.url.includes('/r/')) {
      if (!this.localStorage.getItem(Setting.refCode))
        this.localStorage.setItem(Setting.refCode, this.refCode);
      this.authS
        .trackReferrer(this.refCode)
        .subscribe((res) => console.log(res));
    }
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    if (window.scrollY >= 100) this.isBottom = true;
    else this.isBottom = false;
  }
}
